import PartnerPage from "@/views/partner/PartnerPage.vue";

import Profile from "@/views/partner/children/profile/Profile.vue";
import Dashboard from "@/views/partner/children/dashboard/Dashboard.vue";
import PartnerFinance from "@/views/partner/children/finance/Finance.vue";
import PartnerClasses from "@/views/partner/children/classes/PartnerClasses.vue";
import PartnerClassesForm from "@/views/partner/children/classes/form/PartnerClassesForm.vue";
import CourseIndex from "@/views/partner/children/course/CourseIndex.vue";
import Course from "@/views/partner/children/course/Course.vue";
import CourseContent from "@/views/partner/children/course/CourseContent.vue";
import PartnerTrainings from "@/views/partner/children/trainings/Trainings.vue";
import Calendar from "@/views/partner/children/calendar/Calendar.vue";
import NotificationsArea from "@/views/partner/children/notifications/NotificationsArea.vue";
import PartnerMessages from "@/views/partner/children/messages/Messages.vue";
import SurveyAnswerPage from "@/components/surveys/SurveyAnswerPage.vue";
import ExerciseAttemptReview from "@/views/partner/children/exercises/ExerciseAttemptReview.vue";
import TutoredExercises from "@/views/partner/children/exercises/TutoredExercises.vue";
import ExercisePage from "@/views/customer/children/exercises/ExercisePage.vue";
import PitchCoinsPage from "@/components/coins/PitchCoinsPage.vue";

const prefix = "/connect/professor";

export const partner_routes = [
  {
    path: prefix,
    name: "Bem-vindo",
    component: PartnerPage,
    meta: { authRequired: true, preventAuth: true },
    children: [
      {
        path: `${prefix}/cockpit`,
        name: "Meu progresso",
        component: Dashboard,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/perfil`,
        name: "Perfil",
        component: Profile,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/turmas`,
        name: "Turmas",
        meta: { authRequired: true, preventAuth: true },
        component: PartnerClasses,
      },
      {
        path: `${prefix}/turmas/:id`,
        name: "Detalhe da turma",
        component: PartnerClassesForm,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/curso`,
        name: "Curso",
        meta: { authRequired: true, preventAuth: true },
        component: CourseIndex,
      },
      {
        path: `${prefix}/curso/material/:id`,
        name: "Conteúdo da aula",
        meta: { authRequired: true, preventAuth: true },
        component: CourseContent,
      },
      {
        path: `${prefix}/curso/:id`,
        name: "Aulas do módulo",
        meta: { authRequired: true, preventAuth: true },
        component: Course,
      },
      {
        path: `${prefix}/curso/:module/:id`,
        name: "Material",
        meta: { authRequired: true, preventAuth: true },
        component: CourseContent,
      },
      // Card 86akqwmzy: aba Treinamentos (módulos só de professores). As telas
      // do módulo e da aula são as mesmas de Materiais.
      {
        path: `${prefix}/treinamentos`,
        name: "Treinamentos",
        meta: { authRequired: true, preventAuth: true },
        component: PartnerTrainings,
      },
      {
        path: `${prefix}/treinamentos/:id`,
        name: "Aulas do treinamento",
        meta: { authRequired: true, preventAuth: true },
        component: Course,
      },
      {
        path: `${prefix}/treinamentos/:module/:id`,
        name: "Aula do treinamento",
        meta: { authRequired: true, preventAuth: true },
        component: CourseContent,
      },
      // Card 17trt6jbffe: Mensagens (chat com alunos, turmas e suporte).
      {
        path: `${prefix}/mensagens`,
        name: "Mensagens",
        meta: { authRequired: true, preventAuth: true },
        component: PartnerMessages,
      },
      {
        path: `${prefix}/notificacoes`,
        name: "Notificacoes",
        meta: { authRequired: true, preventAuth: true },
        component: NotificationsArea,
      },
      {
        path: `${prefix}/agenda`,
        name: "Agenda",
        meta: { authRequired: true, preventAuth: true },
        component: Calendar,
      },
      {
        path: `${prefix}/financeiro`,
        name: "Financeiro",
        meta: { authRequired: true, preventAuth: true },
        component: PartnerFinance,
      },
      {
        // Card 17trt6jd8uu: saldo, como ganhar e extrato de coins.
        path: `${prefix}/pitch-coins`,
        name: "Pitch Coins professor",
        meta: { authRequired: true, preventAuth: true },
        component: PitchCoinsPage,
        props: { profile: "partner" },
      },
      {
        // Card 86akqxu0h: formulario de pesquisa enviado pela escola.
        path: `${prefix}/formularios/:id`,
        name: "Formulario professor",
        meta: { authRequired: true, preventAuth: true },
        component: SurveyAnswerPage,
        props: { profile: "partner" },
      },
      // Card 17trt6jcyfb: exercicios dos alunos (correcao e comentario).
      {
        path: `${prefix}/exercicios`,
        name: "Exercicios Autonomy",
        meta: { authRequired: true, preventAuth: true },
        component: TutoredExercises,
      },
      {
        path: `${prefix}/exercicios/tentativas/:id`,
        name: "Correcao de exercicio",
        meta: { authRequired: true, preventAuth: true },
        component: ExerciseAttemptReview,
      },
      // Retorno de 22/10: no treinamento o professor faz o exercício, pela
      // mesma página do aluno.
      {
        path: `${prefix}/exercicios/treinamento/:id`,
        name: "Exercicio do treinamento",
        meta: { authRequired: true, preventAuth: true },
        component: ExercisePage,
        props: { profile: "partner" },
      },
    ],
  },
];
